// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"style-module_avatarContainer__1x2mgk1fiJ1lR_1z6y3gOn"};